var _a;
import * as React from 'react';
import { Footer, Header } from '@gc/global-components';
import { ErrorBoundary } from 'bernie-view';
import { Qualtrics } from '@shared-ui/customer-qualtrics';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { OneKeyOnboardingWrapper } from '@shared-ui/retail-loyalty-one-key-onboarding';
import { getPageName, PageId } from '../utils/page-ids';
import { SimpleLazyLoadWrapper } from '../common/component/simple-lazy-load-wrapper';
import { MesoInit } from '../components/meso';
import { GlobalNavigationLineOfBusiness } from '../common/__generated__/api';
import { ActivitySearch } from '../components/activity-search';
import { VoiceOfCustomer } from '../components/common/voice-of-customer';
var MemoizedFooter = React.memo(Footer);
var footerCSR = React.createElement(ErrorBoundary, {
  label: "lx.splitview.footer"
}, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(MemoizedFooter, {
  skipSsr: true,
  page: (_a = getPageName(PageId.ACTIVITY_SEARCH)) !== null && _a !== void 0 ? _a : 'Unknown'
})));
var ActivitySearchPage = function () {
  return React.createElement("main", {
    className: "white-canvas page-container",
    "data-testid": "activity-search-page"
  }, React.createElement(ErrorBoundary, {
    label: "onekey.onboarding.lx-nimble"
  }, React.createElement(OneKeyOnboardingWrapper, null)), React.createElement(Header, {
    lineOfBusiness: GlobalNavigationLineOfBusiness.ACTIVITY
  }), React.createElement(React.Fragment, null, React.createElement(ErrorBoundary, {
    label: "meso.init"
  }, React.createElement(MesoInit, null))), React.createElement(ActivitySearch, null), React.createElement(VoiceOfCustomer, null), footerCSR, React.createElement(Experiment, {
    name: "LX_NIMBLE_PWA_EGTNL_AA_Test"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  })), React.createElement(Experiment, {
    name: "Activities_DUET_Gate"
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(Qualtrics, null))));
};
export default ActivitySearchPage;